/* =========================================================
Complete Walk Set - Outdoor Paws
The set sells as ONE product line: the customer picks a set colour
and a collar size and the matching Complete Walk Set bundle product
goes into the cart. Personalisation is added separately so the two
buttons can never collide on the same line item.
Falls back to adding the three items individually when no bundle
products have been set in the section settings.
========================================================= */
(function () {
'use strict';
var COLOUR_HEX = { 'Sage': '#8a9a7b', 'Stone': '#cfc6b8', 'Coffee': '#6b5442', 'Lilac': '#c3aee0', 'Midnight': '#2b3442' };
var COLOUR_ORDER = ['Sage', 'Stone', 'Coffee', 'Lilac', 'Midnight'];
var SIZE_ORDER = ['Small', 'Medium', 'Large'];
function colourName(title) {
var keys = Object.keys(COLOUR_HEX), t = (title || '').toLowerCase();
for (var i = 0; i < keys.length; i++) { if (t.indexOf(keys[i].toLowerCase()) >= 0) return keys[i]; }
return (title || 'Colour').trim();
}
function colourHex(name) { return COLOUR_HEX[name] || '#bbb'; }
function rank(list, v) { var i = list.indexOf(v); return i === -1 ? 99 : i; }
function money(cents, format) {
var value = (cents / 100).toFixed(2);
if (format && format.indexOf('{{') !== -1) {
return format.replace(/\{\{\s*amount\s*\}\}/, value)
.replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','));
}
return '$' + value;
}
function moneyShort(cents, format) { return money(cents, format).replace(/\.00\b/, ''); }
class CompleteWalkSet extends HTMLElement {
  connectedCallback() {
  this.moneyFormat = this.getAttribute('data-money-format') || '${{amount}}';
  this.compareAtCents = Math.round(parseFloat(this.getAttribute('data-compare-at') || '0') * 100);
  this.freeShipping = parseInt(this.getAttribute('data-free-shipping'), 10) || 0;
  this.cartTotal = parseInt(this.getAttribute('data-cart-total'), 10) || 0;
  this.qty = 1;
  this.inCart = false;
  this.bundleProducts = this._json('.cws-bundle-data', {}).products || [];
  this.useBundles = this.bundleProducts.length > 0;
  this.items = [];
  Array.prototype.forEach.call(this.querySelectorAll('.cws__item'), function (el) {
  var dataEl = el.querySelector('.cws-item-data');
  if (!dataEl) return;
  var data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
  if (!data.products || !data.products.length) return;
  this.items.push({ el: el, data: data, isCollar: data.isCollar === true || el.dataset.isCollar === 'true', colourIdx: 0, size: null });
  }.bind(this));
  this.collar = this.items.filter(function (it) { return it.isCollar; })[0] || null;
  this.setColours = this.useBundles ? this._bundleColours() : this._commonColours();
  this.setColour = this.setColours[0] || null;
  this.sizes = this._sizesFor(this.setColour);
  this.size = this.sizes[0] || null;
  this._syncFallback();
  this.$colours = this.querySelector('[data-set-colours]');
  this.$colourValue = this.querySelector('[data-colour-value]');
  this.$sizes = this.querySelector('[data-set-sizes]');
  this.$sizeValue = this.querySelector('[data-size-value]');
  this.$sizeWrap = this.querySelector('[data-size-wrap]');
  this.$price = this.querySelector('[data-cws-price]');
  this.$button = this.querySelector('.cws__add');
  this.$buttonText = this.querySelector('.cws__add-text');
  this.$hint = this.querySelector('.cws__hint');
  this.$qtyInput = this.querySelector('[data-qty-input]');
  this.$ship = this.querySelector('[data-cws-ship]');
  this.$shipNote = this.querySelector('[data-cws-ship-note]');
  this.selector = this.querySelector('silicone-letter-selector');
  this.$lettersAdd = this.querySelector('[data-letters-add]');
  this.$lettersUnit = this.querySelector('[data-letters-unit]');
  this.$lettersTotal = this.querySelector('[data-letters-total]');
  this.$lettersHint = this.querySelector('[data-letters-hint]');
  this.letterBreakdown = null;
  this.addEventListener('sls:change', function (e) {
  this.letterBreakdown = e.detail.breakdown;
  this._updateLetters();
  }.bind(this));
  if (this.$lettersAdd) this.$lettersAdd.addEventListener('click', this._addLetters.bind(this));
  if (this.$button) this.$button.addEventListener('click', this._addSet.bind(this));
  this._bindQty();
  this._initSizeGuide();
  this._renderColours();
  this._renderSizes();
  this._update();
  this._updateLetters();
  this._refreshCart();
  }
  _json(sel, fallback) {
  var el = this.querySelector(sel);
  if (!el) return fallback;
  try { return JSON.parse(el.textContent); } catch (e) { return fallback; }
  }
  _bundleColours() {
    var out = [];
    this.bundleProducts.forEach(function (p) { var c = colourName(p.title); if (out.indexOf(c) < 0) out.push(c); });
    return out.sort(function (a, b) { return rank(COLOUR_ORDER, a) - rank(COLOUR_ORDER, b); });
    }
    _coloursOf(item) {
    var seen = {}, out = [];
    item.data.products.forEach(function (p) { var c = colourName(p.title); if (!seen[c]) { seen[c] = 1; out.push(c); } });
    return out;
    }
    _commonColours() {
    if (!this.items.length) return [];
    var counts = {};
    this.items.forEach(function (it) { this._coloursOf(it).forEach(function (c) { counts[c] = (counts[c] || 0) + 1; }); }, this);
    var all = Object.keys(counts);
    var common = all.filter(function (c) { return counts[c] === this.items.length; }, this);
    return (common.length ? common : all).sort(function (a, b) { return rank(COLOUR_ORDER, a) - rank(COLOUR_ORDER, b); });
    }
    _bundleFor(colour) {
    var match = null;
    this.bundleProducts.forEach(function (p) { if (!match && colourName(p.title) === colour) match = p; });
    return match;
    }
    _variantLabel(v) { return (v.options && v.options.length) ? v.options.join(' / ') : v.title; }
    _sizesFor(colour) {
    if (this.useBundles) {
    var p = this._bundleFor(colour);
    if (!p || !p.variants || !p.variants.length) return [];
    if (p.variants.length === 1 && /default title/i.test(this._variantLabel(p.variants[0]) || '')) return [];
    var seen = {}, out = [];
    p.variants.forEach(function (v) { var t = this._variantLabel(v); if (t && !seen[t]) { seen[t] = 1; out.push(t); } }, this);
    return out.sort(function (a, b) { return rank(SIZE_ORDER, a) - rank(SIZE_ORDER, b); });
    }
    if (!this.collar) return [];
    var prod = this._productForColour(this.collar, colour) || this.collar.data.products[0];
    return this._sizesOfProduct(prod);
    }
    _productForColour(item, colour) {
    var match = null;
    item.data.products.forEach(function (p) { if (!match && colourName(p.title) === colour) match = p; });
    return match;
    }
    _sizeOptionIndex(product) {
      if (!product || !product.options) return -1;
      for (var i = 0; i < product.options.length; i++) { if (/size/i.test(product.options[i])) return i; }
      return -1;
      }
      _sizesOfProduct(product) {
      var idx = this._sizeOptionIndex(product);
      if (idx < 0) return [];
      var seen = {}, out = [];
      product.variants.forEach(function (v) { var sz = v.options[idx]; if (sz && !seen[sz]) { seen[sz] = 1; out.push(sz); } });
      return out;
      }
      _currentProduct(item) { return item.data.products[item.colourIdx] || item.data.products[0]; }
      _syncFallback() {
      if (this.useBundles) return;
      this.items.forEach(function (it) {
      var idx = 0;
      it.data.products.forEach(function (p, i) { if (colourName(p.title) === this.setColour) idx = i; }, this);
      it.colourIdx = idx;
      var sizes = this._sizesOfProduct(this._currentProduct(it));
      it.size = sizes.length ? ((this.size && sizes.indexOf(this.size) >= 0) ? this.size : sizes[0]) : null;
      }, this);
      }
      _variantFor(item) {
      var p = this._currentProduct(item), idx = this._sizeOptionIndex(p);
      if (idx < 0) return p.variants[0] || null;
      for (var i = 0; i < p.variants.length; i++) { if (p.variants[i].options[idx] === item.size) return p.variants[i]; }
      return p.variants[0] || null;
      }
      _bundleVariant() {
      var p = this._bundleFor(this.setColour);
      if (!p || !p.variants || !p.variants.length) return null;
      if (!this.size) return p.variants[0];
      for (var i = 0; i < p.variants.length; i++) { if (this._variantLabel(p.variants[i]) === this.size) return p.variants[i]; }
      return p.variants[0];
      }
      _setProps() {
      var p = {};
      if (this.setColour) p['Set colour'] = this.setColour;
      if (this.size) p['Collar size'] = this.size;
      p._cws_set = '1';
      return p;
      }
      _state() {
        if (this.useBundles) {
        var v = this._bundleVariant();
        return {
        price: v ? v.price : 0,
        compare: (v && v.compare) ? v.compare : this.compareAtCents,
        available: !!(v && v.available),
        missing: [],
        lines: v ? [{ id: v.id, quantity: this.qty, properties: this._setProps() }] : []
        };
        }
        var total = 0, ok = this.items.length > 0, lines = [], missing = [];
        this.items.forEach(function (it) {
        var v = this._variantFor(it);
        if (!v) { ok = false; return; }
        if (!v.available) { ok = false; missing.push(it.data.label || 'Item'); }
        total += v.price;
        lines.push({ id: v.id, quantity: this.qty, properties: this._setProps() });
        }, this);
        return { price: total, compare: this.compareAtCents, available: ok, missing: missing, lines: lines };
        }
        _update() {
        var st = this._state();
        if (this.$price) {
        var html = '<span class="cws-price__now">' + money(st.price, this.moneyFormat) + '</span>';
        if (st.compare && st.compare > st.price) {
        html += '<s class="cws-price__was">' + money(st.compare, this.moneyFormat) + '</s>';
        html += '<span class="cws-price__save">Save ' + moneyShort(st.compare - st.price, this.moneyFormat) + '</span>';
        }
        this.$price.innerHTML = html;
        }
        if (this.$button) {
        var ready = st.available && st.lines.length > 0;
        this.$button.disabled = !ready;
        if (this.$buttonText) {
        if (!st.lines.length) this.$buttonText.textContent = 'Choose your options';
        else if (!st.available) this.$buttonText.textContent = (st.missing.length ? st.missing[0] + ' is sold out in that colour and size' : 'Sold out in that colour and size');
        else this.$buttonText.textContent = this.inCart ? 'In cart - add another' : 'Add Walk Set to Cart';
        }
        this.$button.classList.toggle('cws__add--incart', !!(this.inCart && ready));
        }
        }
        _updateLetters() {
          var b = this.letterBreakdown;
          var count = b ? b.count : 0, charms = b ? b.charms : 0, total = b ? b.total : 0;
          var unit = (b && b.unit) || (b && b.charmUnit) || 0;
          if (this.$lettersUnit) this.$lettersUnit.textContent = unit ? money(unit, this.moneyFormat) + ' per letter or charm' : '';
          if (this.$lettersTotal) {
          this.$lettersTotal.textContent = count + (count === 1 ? ' letter' : ' letters') + ' + ' + charms + (charms === 1 ? ' charm' : ' charms') + ' = ' + money(total, this.moneyFormat);
          }
          if (this.$lettersAdd) this.$lettersAdd.disabled = (count + charms) === 0;
          }
          _addLetters(evt) {
          if (evt) evt.preventDefault();
          if (!this.selector) return;
          var built = this.selector.getLetterItems();
          if (!built.valid) { if (this.$lettersHint) this.$lettersHint.textContent = built.error || 'Please fix the letter selection.'; return; }
          if (!built.items.length) return;
          if (this.$lettersHint) this.$lettersHint.textContent = '';
          this._post(built.items, this.$lettersAdd);
          }
          _addSet(evt) {
          if (evt) evt.preventDefault();
          var st = this._state();
          if (!st.available || !st.lines.length) { this._error('Please choose an available colour and size.'); return; }
          this._error('');
          this._post(st.lines, this.$button);
          }
          _post(items, btn) {
          if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
          var routes = (window.theme && theme.routes) || {};
          fetch(routes.cartAdd || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
          })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
          .then(function (res) {
          if (!res.ok) throw new Error((res.body && res.body.description) || 'Could not add to cart');
          this._afterAdd();
          }.bind(this))
          .catch(function (e) { this._error(e.message); }.bind(this))
          .then(function () { if (btn) btn.classList.remove('is-loading'); this._refreshCart(); }.bind(this));
          }
          _afterAdd() {
          var cartType = (window.theme && theme.settings && theme.settings.cartType) || 'drawer';
          if (cartType === 'drawer') {
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
          } else {
          window.location = (window.theme && theme.routes && theme.routes.cart) || '/cart';
          }
          }
          _refreshCart() {
            fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
            this.cartTotal = cart.total_price || 0;
            this.inCart = (cart.items || []).some(function (li) { return li.properties && li.properties._cws_set; });
            this._renderShipping();
            this._update();
            }.bind(this))
            .catch(function () {});
            }
            _renderShipping() {
            if (!this.$ship || !this.freeShipping) return;
            var left = this.freeShipping - this.cartTotal;
            if (left > 0) {
            this.$ship.classList.remove('cws-ship--met');
            if (this.$shipNote) this.$shipNote.textContent = 'Add ' + money(left, this.moneyFormat) + ' more to your cart to unlock free shipping.';
            } else {
            this.$ship.classList.add('cws-ship--met');
            if (this.$shipNote) this.$shipNote.textContent = 'Your order qualifies for FREE SHIPPING.';
            }
            }
            _renderColours() {
            if (!this.$colours) return;
            this.$colours.innerHTML = '';
            if (this.$colourValue) this.$colourValue.textContent = this.setColour || '';
            this.setColours.forEach(function (c) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'cws-swatch';
            b.title = c;
            b.style.background = colourHex(c);
            b.setAttribute('aria-checked', c === this.setColour ? 'true' : 'false');
            b.setAttribute('aria-label', c);
            b.addEventListener('click', function () {
            this.setColour = c;
            this.sizes = this._sizesFor(c);
            if (this.sizes.length && this.sizes.indexOf(this.size) < 0) this.size = this.sizes[0];
            this._syncFallback();
            this._renderColours();
            this._renderSizes();
            this._update();
            }.bind(this));
            this.$colours.appendChild(b);
            }, this);
            }
            _renderSizes() {
            if (!this.$sizes) return;
            if (this.$sizeWrap) this.$sizeWrap.hidden = this.sizes.length === 0;
            this.$sizes.innerHTML = '';
            if (this.$sizeValue) this.$sizeValue.textContent = this.size || '';
            this.sizes.forEach(function (sz) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'cws-size-pill';
            b.textContent = sz;
            b.setAttribute('aria-checked', sz === this.size ? 'true' : 'false');
            b.addEventListener('click', function () {
            this.size = sz;
            this._syncFallback();
            this._renderSizes();
            this._update();
            }.bind(this));
            this.$sizes.appendChild(b);
            }, this);
            }
            _bindQty() {
              var up = this.querySelector('[data-qty-up]');
              var down = this.querySelector('[data-qty-down]');
              var set = function (n) {
              this.qty = Math.max(1, n || 1);
              if (this.$qtyInput) this.$qtyInput.value = this.qty;
              this._update();
              }.bind(this);
              if (up) up.addEventListener('click', function () { set(this.qty + 1); }.bind(this));
              if (down) down.addEventListener('click', function () { set(this.qty - 1); }.bind(this));
              if (this.$qtyInput) this.$qtyInput.addEventListener('change', function () { set(parseInt(this.$qtyInput.value, 10)); }.bind(this));
              }
              _initSizeGuide() {
              var modal = this.querySelector('[data-sizeguide]');
              if (!modal) return;
              var open = function () { modal.hidden = false; document.documentElement.style.overflow = 'hidden'; };
              var close = function () { modal.hidden = true; document.documentElement.style.overflow = ''; };
              Array.prototype.forEach.call(this.querySelectorAll('[data-sizeguide-open]'), function (o) { o.addEventListener('click', open); });
              Array.prototype.forEach.call(modal.querySelectorAll('[data-sizeguide-close]'), function (c) { c.addEventListener('click', close); });
              document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });
              }
              _error(msg) {
              if (!this.$hint) return;
              this.$hint.textContent = msg || '';
              this.$hint.classList.toggle('cws__hint--error', !!msg);
              }
              }
              if (!window.customElements.get('complete-walk-set')) {
              window.customElements.define('complete-walk-set', CompleteWalkSet);
              }
              })();